import React, { useEffect, useRef } from 'react';

export default function WebpagesPagesPanelContextMenu({ x, y, allowPaste, onClose, onAction }) {
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [onClose]);

  if (!allowPaste) return null;

  return (
    <div
      className="z-50 py-1 bg-white border rounded-md shadow-lg border-slate-200"
      style={{
        position: 'fixed',
        top: y,
        left: x,
        minWidth: '160px',
      }}
      ref={ref}
    >
      <button
        type="button"
        className="flex items-center w-full gap-2 px-4 py-2 text-sm text-left cursor-pointer text-slate-700 hover:bg-slate-50"
        onClick={() => {
          onAction('paste');
          onClose();
        }}
      >
        <i className="w-5 fa fa-paste text-slate-400"></i> Paste
      </button>
    </div>
  );
}
